/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Plan_Build_Add_OneInputs */

const en_us2_plan_build_add_one = /** @type {(inputs: Plan_Build_Add_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Add ${i?.name}`)
};

const pt_br2_plan_build_add_one = /** @type {(inputs: Plan_Build_Add_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Adicionar ${i?.name}`)
};

const es_419_plan_build_add_one = /** @type {(inputs: Plan_Build_Add_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Agregar ${i?.name}`)
};

const pt_pt2_plan_build_add_one = /** @type {(inputs: Plan_Build_Add_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Adicionar ${i?.name}`)
};

const fr_fr2_plan_build_add_one = /** @type {(inputs: Plan_Build_Add_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ajouter ${i?.name}`)
};

const de_de2_plan_build_add_one = /** @type {(inputs: Plan_Build_Add_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} hinzufügen`)
};

const it_it2_plan_build_add_one = /** @type {(inputs: Plan_Build_Add_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aggiungi ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Add {name}" |
*
* @param {Plan_Build_Add_OneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_add_one = /** @type {((inputs: Plan_Build_Add_OneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Add_OneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_add_one(inputs)
	if (locale === "es-419") return es_419_plan_build_add_one(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_add_one(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_add_one(inputs)
	if (locale === "de-DE") return de_de2_plan_build_add_one(inputs)
	if (locale === "it-IT") return it_it2_plan_build_add_one(inputs)
	return en_us2_plan_build_add_one(inputs)
});
export { plan_build_add_one as "plan-build.add_one" }